<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
      <router-view/>
    </a-config-provider>
    <div @click="hideLoading" v-show="loading" class="loading"><a-spin tip="Loading..." /></div>
    <a-back-top />
    <router-view  v-if="isRouterAlive"/>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { mapState } from 'vuex'
export default {
  provide(){
    return{
      reload:this.reload
    }
  },
  data() {
    return {
      zh_CN,
      isRouterAlive:false
    }
  },
  computed: {
    ...mapState({
      loading: state => state.loading
    })
  },
  methods:{
    reload (){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
        let that =this
        setTimeout(function (){
          that.isRouterAlive = false
        },200)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4)
}
</style>